import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

export interface AgreementTextPendingChanges {
  canDeactivate: () => boolean | Observable<boolean>;
}

export const agreementTextUnsavedChangesGuard: CanDeactivateFn<AgreementTextPendingChanges> = (
  component,
) => component.canDeactivate();
